(function() { module.exports = this["wp"]["element"]; }());